import { render } from "./LegacyGroupWeeklyDeviceSummaryReport.vue?vue&type=template&id=8deb8228"
import script from "./LegacyGroupWeeklyDeviceSummaryReport.vue?vue&type=script&lang=js"
export * from "./LegacyGroupWeeklyDeviceSummaryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__